"use strict"

import {observable, action} from "mobx"

class ConsentSentDialogStore {
	@observable isOpen = false

	requestId = null
	formRef = null

	@action open(requestId) {
		this.isOpen = true
		this.requestId = requestId
	}

	@action close(form) {
		this.isOpen = false
		this.requestId = null
		form.reset()
	}
}

var singleton = new ConsentSentDialogStore()
export default singleton

